import React from "react"
import { Card } from 'antd'
import styles from './CohortTimeframe.module.scss'
import {CohortPeriodSelector} from "./CohortPeriodSelector";
import {Breakdown} from "./Breakdown";
import {useSelector} from "react-redux";
import {getCurrent} from "../../reducers/util";
import { AppState } from "../../types/AppState";

export const CohortTimeframe = () => {
    const { response } = useSelector((state: AppState) => {
        const current = getCurrent(state)
        return { response: current?.query?.sparkQuery?.response !== undefined ?
                JSON.parse(current.query.sparkQuery.response)
                : undefined
        }
    })

    return <div className={styles.cohortTimeframe}>
        <Card title="Timeline" className={styles['time-frame-card']}>
            <div className={styles.cohortTimeframeWrapper}>
                <CohortPeriodSelector response={response}/>
                <Breakdown response={response}/>
            </div>
        </Card>
    </div>

}